<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1s"><a id="page_5"></a><span class="red">Contents</span></h1>
<p class="toc"><span class="green4"><span href="#/html/9781607052029_04_ded" title="Link target outside of Sample">Dedication</span></span></p>
<p class="toc"><span class="green4"><a href="#/html/9781607052029_06_intro">Introduction</a></span></p>
<p class="toc"><span class="green4"><a href="#/html/9781607052029_07_basic">Basic Supplies</a></span></p>
<p class="toc"><span class="green4"><span href="#/html/9781607052029_08_color" title="Link target outside of Sample">Color and Design</span></span></p>
<p class="toc1"><i>What Color Is “Christmas”?, Contrast and Value, Designs on Fabric, Choosing Fabric for a Quilt</i></p>
<p class="toc"><span class="red">Projects</span></p>
<p class="toc3"><span class="green4"><i><span href="#/html/9781607052029_10_chirist" title="Link target outside of Sample">Christmas in the Park</span></i></span></p>
<p class="toc3"><span class="green4"><i><span href="#/html/9781607052029_11_the" title="Link target outside of Sample">The All Wonderful Red &amp; Green Quilt</span></i></span></p>
<p class="toc3"><span class="green4"><i><span href="#/html/9781607052029_12_caribbean" title="Link target outside of Sample">Caribbean Christmas</span></i></span></p>
<p class="toc3"><span class="green4"><i><span href="#/html/9781607052029_13_circular" title="Link target outside of Sample">Circular Momentum</span></i></span></p>
<p class="toc3"><span class="green4"><i><span href="#/html/9781607052029_14_atreat" title="Link target outside of Sample">A Treat before Takeoff!</span></i></span></p>
<p class="toc3"><span class="green4"><i><span href="#/html/9781607052029_15_thestock" title="Link target outside of Sample">The Stockings Were Hung by the Chimney with Care</span></i></span></p>
<p class="toc3"><span class="green4"><i><span href="#/html/9781607052029_16_perky" title="Link target outside of Sample">Perky Partridge Pincushion/Ornament</span></i></span></p>
<p class="toc"><span class="green4"><span href="#/html/9781607052029_17_generalquilt" title="Link target outside of Sample">General Quiltmaking Instructions</span></span></p>
<p class="toc1"><i>Fabric Preparation, Seam Allowances, Finishing the Quilt, Making Continuous Bias Strips, Sewing the Binding to the Quilt, Making a Label and Sleeve, Signing Your Quilt</i></p>
<p class="toc"><span class="green4"><span href="#/html/9781607052029_18_general" title="Link target outside of Sample">General Appliqué Instructions</span></span></p>
<p class="toc1"><i>Preparing the Backgrounds for Appliqué, Making Appliqué Templates, Using the Templates, Making the Positioning Overlay, Using the Positioning Overlay, Finger-Pressing, Pressing and Trimming the Blocks</i></p>
<p class="toc"><span class="green4"><span href="#/html/9781607052029_19_special" title="Link target outside of Sample">Special Appliqué Techniques</span></span></p>
<p class="toc1">Cutaway Appliqué, Circle Appliqué</p>
<p class="toc"><span class="green4"><span href="#/html/9781607052029_20_author" title="Link target outside of Sample">About the Authors</span></span></p>
<p class="toc"><span class="green4"><span href="#/html/9781607052029_21_source" title="Link target outside of Sample">Sources</span></span><a id="page_6"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781607052029_05_toc.vue?562f0881